import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Table } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

class OrdinacePrehled extends Component {
  state = { novaOrdinace: {} };

  componentDidMount = () => {
    this.nahrajOrdinace();
  };

  nahrajOrdinace = async () => {
    const firmy = await httpService.post(
      config.apiEndpoint + "ordinace/vypis.php"
    );
    this.setState({
      loaded: true,
      ordinace: firmy.data.ordinace,
    });
  };

  zmenaOrdinace = (ordinace_id, attr, val, save) => {
    let { ordinace } = this.state;
    const index = ordinace.findIndex((o) => o.ordinace_id === ordinace_id);
    ordinace[index][attr] = val;
    this.setState({ ordinace });
    if (save) {
      httpService.post(config.apiEndpoint + "ordinace/zmenaDetail.php", {
        ordinace_id,
        attr,
        val,
      });
    }
  };

  novaOrdinace = async () => {
    const { novaOrdinace } = this.state;
    await httpService.post(config.apiEndpoint + "ordinace/novaOrdinace.php", {
      novaOrdinace,
    });
    this.setState({ novaOrdinace: {}, novaOrdinaceShow: false });
    this.nahrajOrdinace();
  };

  render() {
    const { ordinace, loaded, novaOrdinaceShow, novaOrdinace } = this.state;
    return (
      <React.Fragment>
        <Modal
          show={novaOrdinaceShow}
          onHide={() => this.setState({ novaOrdinaceShow: false })}
        >
          <Modal.Header closeButton>Nové testovací místo</Modal.Header>
          <Modal.Body>
            <input
              type="text"
              name="nazev"
              className="form-control"
              placeholder="Název testovacího místa"
              value={novaOrdinace.nazev}
              onChange={(e) =>
                this.setState({
                  novaOrdinace: {
                    ...novaOrdinace,
                    [e.target.name]: e.target.value,
                  },
                })
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.novaOrdinace}
              disabled={!(novaOrdinace.nazev && novaOrdinace.nazev !== "")}
            >
              Vytvořit testovací místo
            </Button>
          </Modal.Footer>
        </Modal>
        <Button onClick={() => this.setState({ novaOrdinaceShow: true })}>
          Nové testovací místo
        </Button>
        <Table className="mt-3">
          <thead>
            <tr>
              <th>Název testovacího místa</th>
              <th>Adresa</th>
              <th>Klíč ÚZIS</th>
              <th>IČP ordinace</th>
              <th>Odesílat</th>
              <th>Odesílat od kdy</th>
            </tr>
          </thead>
          <tbody>
            {ordinace &&
              ordinace.map((o) => (
                <tr key={o.ordinace_id}>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={o.nazev}
                      name="nazev"
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={o.adresa}
                      name="adresa"
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={o.klicUZIS}
                      name="klicUZIS"
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={o.ordinaceICP}
                      name="ordinaceICP"
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      name="odesilatUZIS"
                      checked={o.odesilatUZIS === "1"}
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.checked ? "1" : "0",
                          true
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={o.odesilatUZISod}
                      name="odesilatUZISod"
                      onChange={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.zmenaOrdinace(
                          o.ordinace_id,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

export default OrdinacePrehled;
